<template>
  <v-card flat class="modal-card">
    <v-card-title>
      <span class="headline">{{ formTitle }} Call Forwarding Number</span>
      <v-spacer></v-spacer>
      <v-btn text icon color="grey" @click="onClose">
        <v-icon>mdi-close</v-icon>
      </v-btn>
    </v-card-title>
    <v-form ref="form" v-model="formValid" @submit.prevent="onSave">
      <v-card-text>
        <v-row class="ma-3">
          <v-col cols="12">
            <v-text-field
              autofocus
              autocomplete="off"
              v-model="numberName"
              required
              :rules="[rules.required]"
              label="Name"
              placeholder="Name"
              @input="updateConfig('name', $event)"
              outlined
            ></v-text-field>
          </v-col>
          <v-col cols="12">
            <v-text-field
              autocomplete="off"
              hint="e.g. (555) 555-1212"
              v-mask="masks.phone"
              v-model="phoneNumber"
              required
              :rules="[rules.required, rules.phone]"
              label="Phone Number"
              placeholder="Phone Number"
              @input="updateConfig('phoneNumber', $event)"
              outlined
            ></v-text-field>
          </v-col>
        </v-row>
      </v-card-text>

      <v-card-actions>
        <v-spacer></v-spacer>
        <v-btn
          class="my-4"
          color="primary"
          @click="onSave"
          :disabled="!(listItem ? listItem.isDirty : false)"
          >Save</v-btn
        >
      </v-card-actions>
    </v-form>
  </v-card>
</template>

<script>
import ListItem from "../../../models/ListItem";
import { VALIDATION_RULES } from "../../../helpers/ValidationRules";
import { MASKS } from "../../../helpers/Masks";
import { mask } from "vue-the-mask";
import axios from "axios";
import { API_BASE_URL } from "../../../globalVars";
import { PhoneNumberCleanFormat } from '../../../helpers/phoneNumberFormatter';
// import { USPhoneNumberDisplayFormat, PhoneNumberCleanFormat } from "../../../helpers/phoneNumberFormatter";

export default {
  name: "CallForwardingNumberModal",
  components: {},
  directives: {
    mask
  },
  props: {
    PhoneNumberId: {
      type: Number,
      required: true
    }
  },
  data: function() {
    return {
      formValid: true,
      editedItem: new ListItem(),

      trackingNumberConfig: {},

      numberName: "",
      phoneNumber: null,
      isLocal: false,
      areaCode: "",
      phoneNumbers: [],
      listItem: {},

      masks: MASKS,
      rules: VALIDATION_RULES
    };
  },
  computed: {
    headers() {
      let headers = [
        { text: "Order", value: "rank", sortable: false },
        {
          text: "Name",
          align: "start",
          value: "name",
          sortable: false
        },
        {
          text: "Phone Number",
          align: "start",
          value: "destination_number",
          sortable: false
        }
      ];
      headers.push({ text: "Action", value: "actions", sortable: false });
      return headers;
    },
    formTitle() {
      return this.PhoneNumberId === -1 ? "Add" : "Edit";
    },
    forwardingPhoneTypeId() {
      let listType = this.$store.getters["entities/listTypes/query"]()
        .where("code", value => ["forwarding_number"].includes(value))
        .first();
      if (listType && listType.id) {
        return listType.id;
      }
      return null;
    },
    forwardingPhones() {
      const listType = this.$store.getters["entities/listTypes/query"]()
        .withAllRecursive(1)
        .where("code", value => ["forwarding_number"].includes(value))
        .first();
      return listType;
    }
  },
  created() {
    if (
      this.PhoneNumberId > 0 &&
      this.forwardingPhones.items &&
      this.forwardingPhones.items.length > 0
    ) {
      const vueThis = this;
      const currentItem = this.forwardingPhones.items.filter(phone => {
        return phone.id == vueThis.PhoneNumberId;
      })[0];
      this.listItem = Object.assign({}, currentItem);
      this.numberName = currentItem.name;
      if (currentItem.meta && currentItem.meta.display) {
        this.phoneNumber = currentItem.meta.display;
      }
    } else {
      this.listItem = {
        listTypeId: this.forwardingPhoneTypeId,
        meta: {
          value: null
        }
      };
    }
  },
  methods: {
    onSave() {
      if (this.$refs.form.validate()) {
        const editedItem = this.listItem;
        if (this.PhoneNumberId > 0) {
          this.$store.dispatch(
            "entities/listItems/updateListItem",
            editedItem
          );
        } else {
          this.$store.dispatch(
            "entities/listItems/createListItem",
            editedItem
          );
        }
        this.onClose();
      }
    },
    updateConfig(field, value) {
      if (!this.listItem.meta) {
        this.listItem.meta = {};
      }
      this.listItem.isDirty = true;
      if (field == "name") {
        this.listItem.name = value;
      } else if (field == "phoneNumber") {
        this.listItem.meta.display = value;
        this.listItem.meta.value = `+1${PhoneNumberCleanFormat(value)}`;
      }
    },
    getAvailableCallTrackingNumbers() {
      const vueThis = this;
      let queryData = "";
      if (this.isLocal) {
        queryData = `areaCode=${this.areaCode}`;
      } else {
        queryData = `isTollFree=tree`;
      }
      axios({
        method: "get",
        url: API_BASE_URL + `/account-phone-number?do=search&${queryData}`,
        headers: {
          Authorization: `Bearer ${localStorage.getItem("access_token")}`
        }
      })
        .then(response => {
          vueThis.phoneNumbers = response.data.data.map(num => {
            return num;
          });
        })
        .catch(error => {
          console.error("Failed to get numbers", error);
        });
    },
    onClose() {
      this.$parent.$parent.$parent.$parent.showDialogContainer = false;
      // this.$root.$children[0].$refs["router-view"].$refs[
      //   "settings-center-rail"
      // ].$refs["telecom-pane"].showDialogContainer = false;
    }
  }
};
</script>

<style scoped lang="stylus"></style>
